<template><div><h1>VUX V2.10.1 发布日志</h1>
<h2><a href="/zh-CN/components/x-textarea.html">XTextarea</a></h2>
<ul><li>[fix] 修复回车符导致的字符计算错误 #3784</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.10.1 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.10.1-220.vue?5777aad2